import { render, staticRenderFns } from "./scoreDetail.vue?vue&type=template&id=a63a2536&scoped=true&"
import script from "./scoreDetail.vue?vue&type=script&lang=js&"
export * from "./scoreDetail.vue?vue&type=script&lang=js&"
import style0 from "./scoreDetail.vue?vue&type=style&index=0&id=a63a2536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63a2536",
  null
  
)

export default component.exports